module.exports = __webpack_public_path__ + "static/img/irole.0d81d00.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/bn/irole.png
// module id = w5p5
// module chunks = 7